import moment from "moment";

export default [
  {
    name: "toUSD",
    filter: value => {
      if (!value) {
        return "$0.00";
      }
      return `$${Number.parseFloat(value)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
    }
  },
  {
    name: "toUSDNegParens",
    filter: value => {
      if (!value) {
        return "$0.00";
      }

      var parsedValue = Number.parseFloat(value)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
      
      if(value >= 0){
        return `$${parsedValue}`;
      }

      return `($${parsedValue.replace("-", "")})`;
    }
  },
  {
    name: "USDtoFloat",
    filter: value => {
      if (value) {
        return Number.parseFloat(value.toString().replace(/[$,]/g, ""));
      }
      return 0;
    }
  },
  {
    name: "ariaFormat",
    filter: value => {
      return `${value
        .toLowerCase()
        .replace(/[^a-zA-Z\d\s-_]/g, "")
        .trim()
        .replace(/\s/g, "-")}`;
    }
  },
  {
    name: "idFormat",
    filter: value => {
      return `${value
        .toLowerCase()
        .replace(/[^a-zA-Zd\s-_]/g, "")
        .trim()
        .replace(/\s/g, "-")}`;
    }
  },
  {
    name: "numToAlpha",
    filter: index => {
      const alpha = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      return alpha[index];
    }
  },
  {
    name: "usdToFloat",
    filter: value => {
      if (!value || value.length === 0) {
        return 0;
      }
      return Number.parseFloat(value.replace(/[^\d.]/g, ""));
    }
  },
  {
    name: "address",
    filter: value => {
      let addr = value.address1;

      if (value.address2 !== "" && value.address2 !== null) {
        addr += `, ${value.address2}`;
      }

      addr += `, ${value.city}, ${value.state} ${value.zipCode}`;

      if (
        value.plus4 !== "" &&
        value.plus4 !== null &&
        value.plus4 !== undefined
      ) {
        addr += `-${value.plus4}`;
      }

      return addr;
    }
  },
  {
    name: "ssn",
    filter: value => {
      // return `•••–••–${value.substring(value.length - 4, value.length)}`;
      let newVal = value;

      const format = "•••••";
      // newVal = newVal.replace(/[-–]/g, "");
      newVal = newVal.replace(/[^0-9]/g, "");

      if (format.length > newVal.length) {
        newVal = `${format.substring(0, newVal.length)}`;
      } else {
        newVal = `${format}${newVal.substring(format.length)}`;
      }

      if (newVal.length > 3) {
        newVal = newVal.substring(0, 3) + "-" + newVal.substring(3)
      }

      if (newVal.length > 6) {
        newVal = newVal.substring(0, 6) + "-" + newVal.substring(6)
      }

      return newVal;
    }
  },
  {
    name: "numOnly",
    filter: value => {
      return value.replace(/[^0-9]/g, "");
    }
  },
  {
    name: "decimalPadding",
    filter: (value, numOfPlaces = 2) => {
      let cleanValue = 0;
      if (value) {
        cleanValue = Number(value.toString().replace(/[$,]/g, ""));
      }

      return Number(cleanValue).toFixed(numOfPlaces);
    }
  },
  {
    name: "lastNCharsMasked",
    filter: (value, filterOption = 4) => {
      // returns the last chars and left pads asterisks in front of the string

      if (value && filterOption > 0) {
        var lastChars = "";
        if (value.length > 1) {
          // substrings the last [filterOption] characters
          lastChars = value.toString().substring(value.length - filterOption);
        }

        var asterisks = "";
        var fillLength = 7;
        if (typeof lastChars !== "undefined") {
          var numAsterisks = fillLength - lastChars.length;
          for (var i = 0; i < numAsterisks; i++) {
            asterisks += "*";
          }
        }

        return asterisks + lastChars;
      } else {
        return "";
      }
    }
  },
  {
    name: "dateFormat",
    filter: (value, format = "MM/DD/YYYY") => {
      if (value) {
        return moment(value).format(format);
      }
    }
  },
  {
    name: "payMethod",
    filter: value => {
      if (value === "hsa" || value === "debit") {
        return "Debit";
      }

      return "Bank Account";
    }
  },
  {
    name: "timeAtAddressFilter",
    filter: value => {
      if (value) {
        if(value === "0"){
          return "Less than one year"
        }
        else if(value === "1"){
          return "1 year"
        }
        else if(value === "6"){
          return "More than 6 years"
        }
        else{
          return value + " years";
        }
      }
    }
  },
  {
    name: "timeWithEmployerFilter",
    filter: value => {
      if (value == "0") {
        return "Less than 1 year";
      } 
      else if (value == "1") {
        return "1 year";
      }
      else if (value == "21") {
        return "More than 20 years";
      }
      else{
        return value + " years";
      }
    }
  },
  {
    name: "shortVal",
    filter: value => {
      if (value !== null && value.length >= 20) {
        return value.substring(0, 20) + "...";
      } else {
        return value;
      }
    }
  },
  {
    name: "boolToYesNo",
    filter: value => {
      if (value == true) return "Yes";
      else if (value == false) return "No";
      return value;
    }
  }
];
